import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HeaderSection from './HeaderSection';
import CarouselsList from './CarouselsList';
import { IEvent } from './Carousel';
import { EventModal } from './EventModal';
/* import CookieConsent from "react-cookie-consent"; */

function App() {

    const [selectedEvent, setSelectedEvent] = useState<IEvent>(null);

    return (
        <Router>
            {/* <CookieConsent
                location="bottom"
                buttonText="Got it"
                cookieName="mbn-cookie"
                style={{ background: "#2B373B" }}
                buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
                expires={150}
            >
                This website uses cookies to enhance the user experience.
            </CookieConsent> */}
            <div className="App night-palette-4-bg">
                <HeaderSection />
                <CarouselsList setSelectedEvent={setSelectedEvent} />
            </div>
            <Routes>
                <Route path='/' element={<div style={{display: 'none'}}></div>} />
                <Route path="/event" element={
                    selectedEvent ? <EventModal event={selectedEvent}/> : <Navigate replace to={"/"}/>
                }/>
            </Routes>
        </Router>
    );
}

export default App;